module.exports = __webpack_public_path__ + "img/selected5-min.1ccb0d1b.png";